import axios from 'axios'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  postWidget,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

function postWidget({ commit, state, rootState }, params) {
  // Fetch the groups from the API
  return axios.post('/api/v1/widget', params).then((response) => {
    return response.data
  })
}
